import React, { Fragment } from "react";

const PageContainer = ({ breadcrumbs, children }) => {
  return (
    <Fragment>
      <div className=" page-header dash-breadcrumb">{breadcrumbs}</div>
      {children}
    </Fragment>
  );
};

export default PageContainer;
